import Header from '../../components/Header/Header';
import { Link, useHistory } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { getSchools, getUser, updateUser, deleteUser } from '../../utils/functions';
import Footer from '../../components/Footer/Footer';
import React from 'react';

function UsersEdit(props) {
    const history = useHistory();

    const [user, setUser] = useState();
    const [schools, setSchools] = useState([]);
    useEffect(() => {
        const getAndSetUser = async () => {
            const response = await getUser(props.match.params.userId);

            if (response) {
                setUser(response);
            }
        };
        const getAndSetSchools = async () => {
            const schoolList = await getSchools({
                select: '_id|name',
            });
            setSchools(schoolList.items);
        };

        getAndSetSchools();

        getAndSetUser();
    }, []);

    const userDelete = async () => {
        await deleteUser('/delete', props.match.params.userId);

        history.goBack();
    };

    const onChangeValue = (value, key, index = null, remove = false) => {
        const tempFormParams = Object.assign({}, user);
        if (index !== null) {
            if (remove) {
                tempFormParams[key].splice(index, 1);
            } else {
                if (!tempFormParams[key]) {
                    tempFormParams[key] = [];
                }
                if (tempFormParams[key].length - 1 < index) {
                    while (tempFormParams[key].length - 1 < index) {
                        tempFormParams[key].push(undefined);
                    }
                }
                tempFormParams[key][index] = value;
            }
        } else {
            tempFormParams[key] = value;
        }

        if (key === 'role' && value === 'admin') {
            delete tempFormParams['school'];
        }

        setUser(tempFormParams);
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        if (user.role === 'principal' && !user.school) {
            user.school = schools[0]._id;
        }
        await updateUser(props.match.params.userId, user);

        history.push(`/users`);
    };

    const roleOptions = [
        {
            key: 'admin',
            name: 'Admin',
        },
        {
            key: 'school-admin',
            name: 'School Admin',
        },
        {
            key: 'principal',
            name: 'Principal',
        },
    ];

    const dashboardOptions = [
        {
            key: 'dashboard',
            name: 'Dashboard',
        },
        {
            key: 'csip',
            name: 'CSIP',
        },
    ];

    const onChangePermission = (checked, key) => {
        const tempFormParams = Object.assign({}, user);
        if (checked) {
            tempFormParams.permissions.push(key);
        } else {
            const index = tempFormParams.permissions.indexOf(key);
            if (index > -1) {
                // only splice array when item is found
                tempFormParams.permissions.splice(index, 1); // 2nd parameter means remove one item only
            }
        }

        setUser(tempFormParams);
    };
    return (
        <>
            <Header title={`User Management - ${user?.username || 'New'}`} />
            <main className={'edit-container container'}>
                <div className={'edit-form-info'}>
                    <h3>
                        <Link to={'/'}>Dashboard</Link>
                    </h3>
                    <h3>
                        <Link to={'/CSIP'}>Schools</Link>
                    </h3>
                </div>
                <div className={'edit-form-info'}>
                    <h3>
                        <Link to={'/'}>Dashboard</Link>
                    </h3>
                    <h3>
                        <Link to={'/users'}>Users</Link>
                    </h3>
                    <h3>User - {user?.username || 'New'}</h3>
                </div>
                <form
                    className={'edit-form'}
                    onSubmit={(e) => {
                        onSubmit(e);
                    }}
                >
                    <div className={'flex-2 form-section'}>
                        <div className={'flex-column'}>
                            <h4 className={'label'}>Username:</h4>
                            <input
                                type={'text'}
                                value={user?.username || ''}
                                onChange={(e) => onChangeValue(e.target.value, 'username')}
                                required={true}
                            />
                        </div>
                        <div className={'flex-column'}>
                            <h4 className={'label'}>Email:</h4>
                            <input
                                type={'text'}
                                value={user?.email || ''}
                                onChange={(e) => onChangeValue(e.target.value, 'email')}
                                required={true}
                            />
                        </div>
                    </div>
                    <div className={'flex-2 form-section'}>
                        <div className={'flex-column'}>
                            <h4 className={'label'}>First Name</h4>
                            <input
                                type={'text'}
                                value={user?.first_name || 'first_name'}
                                onChange={(e) => onChangeValue(e.target.value, 'first_name')}
                                required={true}
                            />
                        </div>
                        <div className={'flex-column'}>
                            <h4 className={'label'}>Last Name:</h4>
                            <input
                                type={'text'}
                                value={user?.last_name || ''}
                                onChange={(e) => onChangeValue(e.target.value, 'last_name')}
                                required={true}
                            />
                        </div>
                    </div>
                    <div className={'flex-2 form-section'}>
                        <div className={'flex-column'}>
                            <h4 className={'label'}>Role:</h4>
                            <select value={user?.role || ''} onChange={(e) => onChangeValue(e.target.value, 'role')}>
                                {roleOptions.map((role, index) => (
                                    <option key={index} value={role.key}>
                                        {role.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {user?.role === 'principal' && (
                            <div className={'flex-column'}>
                                <h4 className={'label'}>Schools:</h4>
                                {user?.school ? (
                                    <>
                                        {user.school.map((school, index) => (
                                            <div style={{ position: 'relative' }}>
                                                <select
                                                    value={school || ''}
                                                    onChange={(e) => onChangeValue(e.target.value, 'school', index)}
                                                >
                                                    {schools.map((school, index) => (
                                                        <option key={index} value={school._id}>
                                                            {school.name}
                                                        </option>
                                                    ))}
                                                </select>
                                                {
                                                    <span
                                                        style={{ right: 'unset', marginLeft: '10px', top: '10px' }}
                                                        className={'close-button'}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            onChangeValue(null, 'school', index, true);
                                                        }}
                                                    ></span>
                                                }
                                            </div>
                                        ))}
                                        <select
                                            value={''}
                                            onChange={(e) =>
                                                onChangeValue(e.target.value, 'school', user.school.length)
                                            }
                                        >
                                            <option key={-1} value={''}>
                                                Select school
                                            </option>
                                            {schools.map((school, index) =>
                                                user.school.includes(school._id) ? (
                                                    ''
                                                ) : (
                                                    <option key={index} value={school._id}>
                                                        {school.name}
                                                    </option>
                                                ),
                                            )}
                                        </select>
                                    </>
                                ) : (
                                    <select value={''} onChange={(e) => onChangeValue(e.target.value, 'school', 0)}>
                                        <option key={-1} value={''}>
                                            Select school
                                        </option>
                                        {schools.map((school, index) => (
                                            <option key={index} value={school._id}>
                                                {school.name}
                                            </option>
                                        ))}
                                    </select>
                                )}
                            </div>
                        )}

                        {(user?.role === 'principal' || user?.role === 'school-admin') && (
                            <div className={'flex-column'}>
                                <h4 className={'label'}>School:</h4>
                                {dashboardOptions.map((opt, index) => (
                                    <div>
                                        <label>{opt.name}</label>
                                        <input
                                            type="checkbox"
                                            checked={user.permissions.includes(opt.key)}
                                            key={index}
                                            onChange={(e) => onChangePermission(e.target.checked, opt.key)}
                                        />
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className={'form-section'}>
                        <button type={'submit'}>Save</button>
                        <button onClick={() => userDelete()} className={'delete-user-btn'}>
                            Delete User
                        </button>
                    </div>
                </form>
            </main>
            <Footer />
        </>
    );
}

export default UsersEdit;
